import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/bitbucket': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M22.2 32l466.8 0.2c0.8 0 2 0.1 2.8 0.2 7.4 1.2 13.4 8.3 13.4 15.8 0 0.7-0.1 1.8-0.2 2.5l-67.9 416.8c-1.2 7.4-8.3 13.4-15.8 13.4-0.1 0-0.2 0-0.2 0h-325.7c-10.1-0.1-19.6-8.2-21.3-18.2l-67.9-412.1c-0.1-0.8-0.2-2-0.2-2.8 0.1-8.7 7.3-15.8 16-15.8 0.1 0 0.1 0 0.2 0zM308.1 329.8l25.2-147h-157.3l28.1 147h104z'
      }
    ]
  }
})
